import React, { createContext, useContext } from 'react'

type CreateEntityElement = (value: string) => React.ReactNode

type CreateEntityElementContextType = {
  createEntityElement: CreateEntityElement
  excludedEntitiesIds: string[]
}
const CreateEntityElementContext = createContext(
  {} as CreateEntityElementContextType,
)

export const useCreateEntityElement = () =>
  useContext(CreateEntityElementContext)

type CreateEntityProviderProps = {
  createEntityElement: CreateEntityElement
  children: React.ReactNode
  excludedEntitiesIds: string[]
}

export function CreateEntityProvider({
  createEntityElement,
  children,
  excludedEntitiesIds,
}: CreateEntityProviderProps) {
  return (
    <CreateEntityElementContext.Provider
      value={{ createEntityElement, excludedEntitiesIds }}
    >
      {children}
    </CreateEntityElementContext.Provider>
  )
}
